module.exports = __webpack_public_path__ + "img/scb-speedy-cash.043cbc96.png";